import { useState } from "react"
import Search from "./Search";
import AdvanceSearch from "./AdvanceSearch";
import SearchResults from "./SearchResults";
import PolicyInfoPage from "../PolicyInfo/PolicyInfoPage";
import ClaimForm from "../ClaimForm/ClaimForm";
import LoadingPage from "../../../../reusableComponents/loader/loadingPage";

const defaultSearch = {
        product_name: "",
        search_type: { label: "Policy ID", value: 1 },
        search_type_value: "",
        state: "",
        district: "",
        mandal: "",
        village: "",
        pincode: "",
        policyHolderName: ""
}
const searchTypes = [
        { label: "Policy ID", value: 1 },
        { label: "Mobile Number", value: 2 },
        { label: "Customer ID", value: 3 },
        // { label: "Advance Search", value: 4 },
]; 
const SearchPage = ({productNames}) => {
    const [showAdvanceSearch, setShowAdvanceSearch] = useState(false);
    const [searchFields, setSearchFields] = useState(defaultSearch);
    const [searchResults, setSearchResults] = useState(null);
    const [loading, setLoading]=useState(false);
    const [showPolicyDetails, setShowPolicyDetails] = useState(false);
    const [showClaimForm, setShowClaimForm] = useState(false);
    const [selectedPolicyData, setSelectedPolicyData] = useState(null)

    return (
        <>
            <div >
                <header>
                    <h2 id = "heading-intimation" className="ms-4 d-flex text-dark">Claim Intimation</h2>
                </header>
            </div>
            {showClaimForm? (<ClaimForm setShowClaimForm={setShowClaimForm} policyData={selectedPolicyData} setLoading={setLoading}/>): (
            showPolicyDetails ? (
                <PolicyInfoPage setShowPolicyDetails={setShowPolicyDetails} setShowClaimForm={setShowClaimForm} policyDetails={selectedPolicyData} setLoading={setLoading}/>
            ): (
                <>
            <Search
                productName = {productNames}
                defaultSearch = {defaultSearch}
                searchTypes = {searchTypes}
                searchFields = {searchFields}
                setSearchFields = {setSearchFields}
                searchResults = {searchResults}
                setSearchResults = {setSearchResults}
                setShowAdvanceSearch = {setShowAdvanceSearch}
                setLoading={setLoading}
            />
            {showAdvanceSearch && (
                <>
                    <AdvanceSearch
                        searchFields = {searchFields}
                        setSearchFields = {setSearchFields} 
                        showAdvanceSearch={showAdvanceSearch}
                        setSearchResults = {setSearchResults} 
                    />
                </>
            )}
            {searchResults && (
                <>
                    <SearchResults
                        searchResults = {searchResults}
                        setShowPolicyDetails = {setShowPolicyDetails}
                        setSelectedPolicyData={setSelectedPolicyData}
                    />
                </>
            )}
            </>
            ))}
            {loading && (
                <LoadingPage kshemaLoader/>
            )}
        </>
    )
};

export default SearchPage;